import React from 'react';

const DeviceContext = React.createContext('web');

export default DeviceContext;
